export const navLinks = [
  { key: "home", label: "首页" },
  { key: "verdict", label: "实测结论" },
  { key: "features", label: "核心功能" },
  { key: "tutorial", label: "上手教程" },
  { key: "guides", label: "玩法攻略" },
  { key: "reviews", label: "用户口碑" },
  { key: "faq", label: "常见问题" },
];

export const heroTags = ["实时热搜", "八卦聚合", "热点吃瓜", "全网资讯"];

export const stats = [
  { value: "4.7", label: "综合评分" },
  { value: "9.1", label: "上手难度" },
  { value: "12+", label: "实用功能" },
  { value: "98%", label: "追瓜满意度" },
];

export const scoreItems = [
  { label: "资讯丰富度", score: 9.4 },
  { label: "更新时效性", score: 9.6 },
  { label: "操作易用性", score: 9.2 },
  { label: "界面美观度", score: 8.8 },
];

export const verdictPros = [
  { icon: "ri-flashlight-line", title: "实时聚合热搜", desc: "全网热搜、热榜、八卦资讯实时抓取汇总，一屏掌握当下最火话题，追瓜不迷路。" },
  { icon: "ri-focus-3-line", title: "事件脉络梳理", desc: "从瓜的起源到发酵，按时间线自动整理完整事件脉络，让你一次吃透前因后果。" },
  { icon: "ri-rocket-line", title: "极低上手门槛", desc: "打开即用，无需复杂设置。下拉刷新、侧滑切换，几分钟就能熟练玩转所有功能。" },
  { icon: "ri-user-heart-line", title: "轻量不打扰", desc: "体积小、推送可控，不夹带广告垃圾信息，安静地当一个纯粹追热点的小助手。" },
];

export const verdictCons = [
  { icon: "ri-calendar-line", title: "历史信息有遗漏", desc: "长线旧瓜的整理稍弱，偏重当下热门话题，查询很久以前的事件脉络需要结合搜索。" },
  { icon: "ri-cloud-off-line", title: "需联网使用", desc: "所有热点内容依赖实时网络，断网或弱网环境下无法查看最新资讯。" },
];

export const features = [
  { icon: "ri-fire-line", title: "全网热榜", color: "bg-accent-500", desc: "聚合微博、论坛、短视频等多平台热榜，热度排序一眼看清大家都在吃哪个瓜。" },
  { icon: "ri-timer-flash-line", title: "实时推送", color: "bg-primary-500", desc: "自定义关注话题的即时提醒，重大瓜刚爆就第一时间通知你，不错过任何精彩。" },
  { icon: "ri-node-tree", title: "事件时间线", color: "bg-secondary-500", desc: "复杂瓜自动整理为清晰时间线，谁说的、什么反转、进展到哪，一目了然。" },
  { icon: "ri-list-settings-line", title: "个性关注", color: "bg-accent-500", desc: "按领域、明星、话题建立你的专属关注清单，只推你真正感兴趣的八卦。" },
  { icon: "ri-chat-smile-2-line", title: "观点聚合", color: "bg-primary-500", desc: "汇总各路网友与媒体的热评观点，帮你快速了解不同立场，吃瓜更立体。" },
  { icon: "ri-bookmark-2-line", title: "离线收藏", color: "bg-secondary-500", desc: "中意的话题一键收藏与归档，整理你的吃瓜笔记，随时回看精彩时刻。" },
];

export const tutorialSteps = [
  {
    step: "01",
    icon: "ri-download-cloud-2-line",
    title: "下载安装",
    desc: "在应用商店搜索「吃瓜神器」，或前往官网获取安装包，完成下载安装即可。",
    tip: "认准官方渠道，避免下载到第三方捆绑版本。",
  },
  {
    step: "02",
    icon: "ri-user-add-line",
    title: "首次设置",
    desc: "打开后按引导完成基础设置，勾选你感兴趣的领域与话题，建立个性化关注清单。",
    tip: "领域选得越细，推送越合你口味。",
  },
  {
    step: "03",
    icon: "ri-home-smile-2-line",
    title: "认识首页热榜",
    desc: "首页即全网热榜，按热度排序。下拉刷新获取最新内容，点进话题查看完整事件。",
    tip: "右侧小标签代表实时热度，越烫手越靠前。",
  },
  {
    step: "04",
    icon: "ri-play-circle-line",
    title: "开启追瓜玩法",
    desc: "从发现页探索话题库，开启事件时间线、实时推送与收藏，正式开启你的吃瓜日常。",
    tip: "先从小众话题练手，上手再追大瓜更稳。",
  },
];

export const guideTabs = [
  {
    key: "beginner",
    label: "入门玩法",
    icon: "ri-seedling-line",
    title: "新手起步：5 分钟建立你的吃瓜节奏",
    intro: "刚下载吃瓜神器别急着到处点，先按这套节奏把基础玩法跑通，追瓜效率直接翻倍。",
    steps: [
      "先逛首页热榜 10 分钟，感受热度排序逻辑与内容密度。",
      "点开 3~5 个你感兴趣的话题，熟悉事件时间线与评论聚合的阅读方式。",
      "进入设置，把娱乐、影视、综艺等高频领域加入关注清单。",
      "开启 1~2 个重磅话题的实时推送，体验边刷边追的节奏。",
    ],
    result: "完成后，你就掌握了吃瓜神器的核心操作，可以自由追日常热点。",
  },
  {
    key: "expert",
    label: "进阶技巧",
    icon: "ri-star-smile-line",
    title: "进阶玩家：把吃瓜神器用出信息流专业感",
    intro: "想让吃瓜更高效、更专业？这几招进阶技巧值得一试。",
    steps: [
      "善用「事件时间线」反查整起瓜的完整脉络，不再只看到片段。",
      "建立多个细分关注清单，比如「顶流动态」「综艺内幕」「社会热点」分开管理。",
      "结合搜索功能，按关键词深挖背景，把冷知识也补齐。",
      "遇到反转，先看观点聚合区，快速掌握多方立场再下判断。",
    ],
    result: "熟练后你不仅能追到最新瓜，还能一眼看穿事件全貌，成为朋友圈的「吃瓜分析师」。",
  },
  {
    key: "share",
    label: "安利场景",
    icon: "ri-hand-heart-line",
    title: "怎么把吃瓜神器安利给朋友最有效",
    intro: "想让身边的朋友也一起快乐吃瓜？看准不同人群，用对安利话术，成功率更高。",
    steps: [
      "给爱追星的朋友：突出「实时推送」和「明星动态」，强调不错过任何营业与瓜料。",
      "给爱八卦的朋友：秀一秀「事件时间线」，一次讲清复杂反转有多爽。",
      "给怕麻烦的朋友：强调「打开即用、无需设置」，几分钟就能上手。",
      "最好的安利是你自己的体验，陪他逛 5 分钟首页热榜，比说一百句都有用。",
    ],
    result: "用场景打动而不是硬推，朋友一旦用上，就会反过来带你冲浪。",
  },
];

export const reviews = [
  {
    name: "柠檬气泡水",
    tag: "追星党",
    avatar: "柠",
    score: 5,
    text: "最看重的是实时推送，我担一发物料或者有瓜，永远比别人先知道，抢前排毫无压力！",
  },
  {
    name: "摸鱼小刘",
    tag: "上班族",
    avatar: "刘",
    score: 4.5,
    text: "午休摸鱼神器，刷几分钟就把上午漏掉的热点补回来了，事件时间线尤其好用，吃瓜吃得很明白。",
  },
  {
    name: "吃瓜十级学者",
    tag: "重度用户",
    avatar: "学",
    score: 5,
    text: "观点聚合真的很加分，反转瓜看评论区立场比自己去补要快太多，吃瓜效率翻倍。",
  },
  {
    name: "晚风里的橘子",
    tag: "内容博主",
    avatar: "橘",
    score: 4.5,
    text: "做内容需要追热点，吃瓜神器的热榜帮我省了大量翻资讯的时间，选题灵感也变多了。",
  },
];

export const faqList = [
  {
    q: "吃瓜神器是什么？",
    a: "吃瓜神器是一款聚合热搜八卦、娱乐资讯与社会热点话题的工具，能按热度一键汇总全网吃瓜信息，帮助用户快速掌握新鲜事与追瓜进度。",
  },
  {
    q: "吃瓜神器好用吗？",
    a: "整体来说吃瓜神器是值得用的，尤其适合喜欢追热点、吃瓜的用户。它实时聚合热搜、梳理事件脉络，上手门槛低、体验流畅，综合评分较高，好用。",
  },
  {
    q: "吃瓜神器怎么安装使用？",
    a: "在应用商店搜索「吃瓜神器」或前往官网下载，安装后完成领域关注等首次设置即可使用。从首页热榜开始浏览，几分钟就能掌握核心玩法。",
  },
  {
    q: "吃瓜神器需要付费吗？",
    a: "基础功能完全免费即可使用，覆盖日常追热点的大部分需求。进阶的个性化、更细颗粒度体验是否收费，以工具内展示的版本说明为准。",
  },
  {
    q: "吃瓜神器的信息来源准确吗？",
    a: "吃瓜神器聚合的是各大平台公开的热搜与资讯，并整理事件时间线帮助你看清脉络。不过网络信息时有反转，建议多方参考、理性看待。",
  },
  {
    q: "吃瓜神器和普通资讯 App 有什么区别？",
    a: "普通资讯 App 偏新闻浏览，吃瓜神器更聚焦八卦、娱乐与社会热点的「追瓜」场景，强调实时热度、事件时间线、观点聚合与个性化关注，更懂吃瓜用户。",
  },
];

export const footerColumns = [
  {
    title: "快速导航",
    links: [
      { label: "实测结论", href: "#verdict" },
      { label: "核心功能", href: "#features" },
      { label: "上手教程", href: "#tutorial" },
      { label: "玩法攻略", href: "#guides" },
    ],
  },
  {
    title: "更多内容",
    links: [
      { label: "用户口碑", href: "#reviews" },
      { label: "常见问题", href: "#faq" },
      { label: "留言交流", href: "#contact" },
      { label: "返回顶部", href: "#home" },
    ],
  },
];